import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createElementVNode as _createElementVNode, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c91bd6d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list" }
const _hoisted_2 = {
  key: 0,
  class: "empty"
}
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "header" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-tip" }, null, -1))
const _hoisted_6 = { class: "time" }
const _hoisted_7 = ["onClick"]

import { ref, onMounted } from 'vue'
import { queryDevicePhysicsLastOnceList } from '@/api'
import { useRouter, useRoute } from 'vue-router'
import { CODE_ENUM, DEVICE_VAR_TYPE } from '@/common'
import moment from 'moment'
import Text from '@/components/text'
import VarCustom from './var-custom.vue'
import Water from '@/components/var-component/water.vue'
import Normal from '@/components/var-component/normal.vue'
import HistoryChart from './history-chart.vue'
import { getDate } from '@/utils'


export default /*#__PURE__*/_defineComponent({
  __name: 'var-list',
  emits: ['on-data'],
  setup(__props, { emit: __emit }) {

const componentMap = {
  [DEVICE_VAR_TYPE.DEFAULT]: Normal,
  [DEVICE_VAR_TYPE.WATER]: Water,
}

const $emit = __emit

const $route = useRoute()
const router = useRouter()

const deviceId = $route.query.deviceId || ''

// fuck 特殊处理以及处理单位
const formatterMap: any = {
  outerBatVol: ({ value, unit }: any) => {
    const num = Number(value)

    if (num < 4000) {
      return {
        value: '无外部供电',
        unit: '',
      }
    }
    return {
      value,
      unit,
    }
  },
}

const loading = ref(false)

const varList: any = ref([])
const fetchList = async () => {
  loading.value = true
  const res: any = await queryDevicePhysicsLastOnceList({
    gatewayDeviceId: deviceId,
  }).finally(() => {
    loading.value = false
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    varList.value = (res.data || []).map((item: any) => {
      const fn = formatterMap[item.code]
      const params = fn ? fn(item) : {}
      return {
        ...item,
        ...params,
      }
    })
  }
}

const formatterTime = (updateTime: any) => {
  return updateTime ? moment(updateTime).format('YYYY-MM-DD HH:mm:ss') : '-'
}

onMounted(() => {
  fetchList()
})

// 查看历史数据
const toData = (data: any) => {
  const { code, value } = data
  if (value === null) {
    return
  }
  $emit('on-data', { deviceId, code, subDeviceId: data.deviceId })
}

const varConf = ref({
  visible: false,
  data: {},
})

const handleCustom = (data: any) => {
  varConf.value = {
    visible: true,
    data,
  }
}

const chartConf = ref({
  visible: false,
  data: {},
})
const handleChart = ({ code, deviceId, statisticsFlag }: any) => {
  if (!statisticsFlag) {
    return
  }
  const time = getDate(3, 'M')
  chartConf.value = {
    visible: true,
    data: {
      time,
      attributeIndexAndDeviceId: code + '-' + deviceId,
    },
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (varList.value.length === 0)
        ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_el_empty, { description: "暂无数据" })
          ])), [
            [_directive_loading, loading.value]
          ])
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(varList.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "list-item ws_mb20",
          key: index
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", _hoisted_4, [
              _createVNode(_unref(Text), {
                content: item.name
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.name), 1)
                ]),
                _: 2
              }, 1032, ["content"]),
              (item.desc)
                ? (_openBlock(), _createBlock(_component_el_tooltip, {
                    key: 0,
                    content: item.desc,
                    placement: "top"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 2
                  }, 1032, ["content"]))
                : _createCommentVNode("", true)
            ])
          ]),
          (_openBlock(), _createBlock(_resolveDynamicComponent(componentMap[item.presentMode || _unref(DEVICE_VAR_TYPE).DEFAULT]), _normalizeProps(_guardReactiveProps({
          ...item,
        })), null, 16)),
          _createElementVNode("p", _hoisted_6, "更新时间：" + _toDisplayString(formatterTime(item.updateTime)), 1),
          _createElementVNode("i", {
            onClick: ($event: any) => (handleChart(item)),
            class: _normalizeClass(["icon-statistics", {
          'icon-statistics-disabled': !item.statisticsFlag,
        }])
          }, null, 10, _hoisted_7)
        ]))
      }), 128))
    ]),
    _createVNode(HistoryChart, {
      visible: chartConf.value.visible,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((chartConf.value.visible) = $event)),
      data: chartConf.value.data
    }, null, 8, ["visible", "data"])
  ], 64))
}
}

})